var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.32 10.82L21.66 1.16C20.92 0.42 19.9 0 18.84 0H4.5C2.3 0 0.52 1.8 0.52 4L0.5 36C0.5 38.2 2.28 40 4.48 40H28.5C30.7 40 32.5 38.2 32.5 36V13.66C32.5 12.6 32.08 11.58 31.32 10.82ZM22.1 26H18.5V32C18.5 33.1 17.6 34 16.5 34C15.4 34 14.5 33.1 14.5 32V26H10.92C10.02 26 9.58 24.92 10.22 24.3L15.82 18.72C16.22 18.34 16.84 18.34 17.24 18.72L22.82 24.3C23.42 24.92 22.98 26 22.1 26ZM20.5 14C19.4 14 18.5 13.1 18.5 12V3L29.5 14H20.5Z",
    fill: "#ACACAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/UploadIcon.f8f48ceb0379abecb54fceb9e01702c3.svg";
export { ForwardRef as ReactComponent };